// extracted by mini-css-extract-plugin
export default {"addIcon":"style_addIcon__JKTgF"};